import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../helpers/reducerRegistry'
import { getNewsTypeThunk, getSentimentsThunk } from './thunk'

const slice = createSlice({
  name: 'common/news',
  initialState: {
    newsTypes: [],
    sentiments: [],
  },
  extraReducers: (builder) => {
    builder
      .addCase(getNewsTypeThunk.pending, (state) => {
        state.newsTypes = []
      })
      .addCase(getNewsTypeThunk.fulfilled, (state, { payload = [] }) => {
        state.newsTypes = payload.map((item) => ({
          ...item,
          children: item.child_NewsTypeResponse || [],
        }))
      })
      .addCase(getNewsTypeThunk.rejected, () => {})

    builder
      .addCase(getSentimentsThunk.pending, (state) => {
        state.sentiments = []
      })
      .addCase(getSentimentsThunk.fulfilled, (state, { payload = [] }) => {
        state.sentiments = payload
      })
      .addCase(getSentimentsThunk.rejected, () => {})
  },
})

export const selectNewsTypes = (state) => state[slice.name].newsTypes
export const selectSentiments = (state) => state[slice.name].sentiments

register(slice.name, slice.reducer)
